"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const styled_1 = __importDefault(require("@mui/material/styles/styled"));
exports.default = (0, styled_1.default)((props) => ((0, jsx_runtime_1.jsx)(Switch_1.default, Object.assign({ focusVisibleClassName: ".Mui-focusVisible", disableRipple: true }, props))))(({ theme }) => ({
    width: 51,
    height: 30,
    padding: 0,
    borderRadius: 99,
    '.MuiSwitch-switchBase': {
        padding: 1,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(21px)',
            color: '#fff',
            '&+.MuiSwitch-track': {
                backgroundColor: '#4cd964',
                opacity: 1,
                border: 0,
            },
            // '&.Mui-disabled + .MuiSwitch-track': {
            //   opacity: 0.5,
            // },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
        // '&.Mui-disabled .MuiSwitch-thumb': {
        //   color:
        //     theme.palette.mode === 'light'
        //       ? theme.palette.grey[100]
        //       : theme.palette.grey[600],
        // },
        // '&.Mui-disabled + .MuiSwitch-track': {
        //   opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        // },
    },
    '.MuiSwitch-thumb': {
        // boxSizing: 'border-box',
        width: 28,
        height: 28,
        boxShadow: '0px 2px 2px rgba(50, 50, 71, 0.06), 0px 2px 4px rgba(50, 50, 71, 0.06)',
    },
    '.MuiSwitch-track': {
        borderRadius: 10,
        backgroundColor: '#e8eaed',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));
